// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RestaurantCarouselItem_wrapper__jb5RU","activeFilter":"RestaurantCarouselItem_activeFilter__3QyBE"};